module.exports = __webpack_public_path__ + "ai.b3fbdf3bb9fe35777c80.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ai.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ai.svg
// module chunks = styles